import { AssetStatus, ParameterScope, type ParameterSet } from '@k-ucap/shared';

export interface ParameterSetService {
  merge(parameterSets: ParameterSet[]): Record<string, unknown>;
  filterForMessageType(parameterSets: ParameterSet[], messageType: number): ParameterSet[];
  validate(parameterSet: ParameterSet): { valid: boolean; issues: string[] };
}

export const createParameterSetService = (): ParameterSetService => {
  const merge = (parameterSets: ParameterSet[]): Record<string, unknown> => {
    const result: Record<string, unknown> = {};
    for (const ps of parameterSets) {
      if (ps.status === AssetStatus.ARCHIVED) continue;
      Object.assign(result, ps.values);
    }
    return result;
  };

  const filterForMessageType = (parameterSets: ParameterSet[], messageType: number): ParameterSet[] => {
    return parameterSets
      .filter((ps) => ps.status !== AssetStatus.ARCHIVED)
      .filter(
        (ps) => ps.scope === ParameterScope.GLOBAL || ps.messageType === undefined || ps.messageType === messageType
      )
      .sort((a, b) => {
        const scopeRank = (scope: ParameterScope) =>
          scope === ParameterScope.TEMPLATE ? 3 : scope === ParameterScope.MESSAGE_TYPE ? 2 : 1;
        return scopeRank(b.scope) - scopeRank(a.scope);
      });
  };

  const validate = (parameterSet: ParameterSet): { valid: boolean; issues: string[] } => {
    const issues: string[] = [];
    if (!parameterSet.name.trim()) issues.push('Parameter set name is required');
    if (!parameterSet.values || Object.keys(parameterSet.values).length === 0) {
      issues.push('Parameter set has no values');
    }
    return { valid: issues.length === 0, issues };
  };

  return { merge, filterForMessageType, validate };
};
